import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import Hero from '../components/Hero';
import TrustBar from '../components/TrustBar';
import Intro from '../components/Intro';
import Services from '../components/Services';
import ConnectedGrowth from '../components/ConnectedGrowth';
import WhyUs from '../components/WhyUs';
import StoryAndTeam from '../components/StoryAndTeam';
import ProcessAndFit from '../components/ProcessAndFit';
import AICallout from '../components/AICallout';
import FAQ, { faqs } from '../components/FAQ';
import Contact from '../components/Contact';

const Home = () => {
  const location = useLocation();

  useEffect(() => {
    if (location.state?.scrollTo) {
      const id = location.state.scrollTo;
      setTimeout(() => {
        const element = document.getElementById(id);
        if (element) {
          const offset = 80; 
          const bodyRect = document.body.getBoundingClientRect().top;
          const elementRect = element.getBoundingClientRect().top;
          const elementPosition = elementRect - bodyRect;
          const offsetPosition = elementPosition - offset;
          window.scrollTo({
            top: offsetPosition,
            behavior: 'smooth'
          });
        }
      }, 100); 
    } else if (!location.hash) {
      window.scrollTo(0, 0);
    }
  }, [location]);

  // Generate FAQ Schema dynamically
  const faqSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": faqs.map(faq => ({
      "@type": "Question",
      "name": faq.question,
      "acceptedAnswer": {
        "@type": "Answer",
        "text": faq.answer
      }
    }))
  };

  const orgSchema = {
    "@context": "https://schema.org",
    "@type": "Organization",
    "name": "LAJ Digital",
    "url": "https://lajdigital.com",
    "logo": "https://media-manager-c.questera.ai/greta-media/1593c15ad88356866a2eabcebc8aef2c67d9fc5afee8d56439ced245a0c6c3417efffbd95aedd1b6f68107af9f17a1fd/images/aW1hZ2UvcG5n/7cf330b2fb2aaf6b54c2cba38f69981f.png",
    "description": "Strategy, Technology, and Growth. One Team for Everything Your Business Needs to Grow Online."
  };

  return (
    <main>
      <Helmet>
        <title>LAJ Digital | Strategy, Technology, and Growth</title>
        <meta name="description" content="LAJ Digital combines marketing strategy, website development, lead generation, custom software, and AI automation into one complete digital growth team." />
        <link rel="canonical" href="https://lajdigital.com/" />
        <script type="application/ld+json">{JSON.stringify(orgSchema)}</script>
        <script type="application/ld+json">{JSON.stringify(faqSchema)}</script>
      </Helmet>
      
      <Hero />
      <TrustBar />
      <Intro />
      <Services />
      <ConnectedGrowth />
      <WhyUs />
      <StoryAndTeam />
      <ProcessAndFit />
      <AICallout />
      <FAQ />
      <Contact />
    </main>
  );
};

export default Home;